import { render, staticRenderFns } from "./LoanPending.vue?vue&type=template&id=6718c2e3"
import script from "./LoanPending.vue?vue&type=script&lang=js"
export * from "./LoanPending.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports